import React from 'react';

import { Unauthorized } from '../../components/Unauthorized/Unauthorized';

export const UnauthorizedView: React.FC = () => {
  return <Unauthorized />;
};
